export default "__VITE_ASSET__BhZ0O7TH__"